/**
 * Foundation
 *
 * Scripts to support Foundation certain components.
 *
 * @see https://github.com/foundation/foundation-sites/blob/develop/dist/js/foundation.js
 * @module
 */

import { up } from '../../utilities/QuerySelectors.js';

class Foundation {
    /**
     * Allows closing elements such as the "callout".
     *
     * @return {void}
     */
    static initClosableElements() {
        document.addEventListener('click', (e) => {
            // @ts-ignore: cannot easily cast e.target to HTMLElement
            const ancestor = up(e.target, '[data-closable]');
            if (!ancestor) {
                return;
            }
            // @ts-ignore: cannot easily cast e.target to HTMLElement
            if (e.target.hasAttribute('data-close') || e.target.querySelector('[data-close]')) {
                // @ts-ignore: cannot easily cast Element to HTMLElement
                ancestor.style.display = 'none';
            }
        });
    }
}

/**
 * Initialize JS pagination component for each .pagination element in the document.
 *
 * @return {void}
 */
export function init() {
    Foundation.initClosableElements();
}
